import React, { useEffect } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"
import { logoutUser } from "../../store/actions"

//redux
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { setLogoutUser } from "redux/slice/user/userSlice"

const Logout = () => {
  const history = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setLogoutUser(history))
  }, [dispatch, history])

  return <></>
}

Logout.propTypes = {
  history: PropTypes.object,
}

export default Logout
